export const Constants = {
	TEMP_ID_PLACEHOLDER: '___TEMP_ID_'
}